import { ScreenComponent } from './ScreenComponent';

export enum ScreenSection {
  Join = 'Join'
}

export interface Screen {
  id: number;
  name: string;
  section?: ScreenSection;
  components: ScreenComponent<any>[];
}
